import { dynamicPageTemplates } from '@/dynamicPageTemplates';
import { logger } from '@/helpers/logger';

export type DynamicPageProps = {
  template?: keyof typeof dynamicPageTemplates;
  [key: string]: unknown;
};

export const DynamicPage = ({ template, ...props }: DynamicPageProps) => {
  if (
    template?.endsWith('RedirectPage') &&
    !(template in dynamicPageTemplates)
  ) {
    return null;
  }

  if (!template || !(template in dynamicPageTemplates)) {
    logger.error(
      `Unknown page template "${template}". Props: ${JSON.stringify(props)}`
    );

    return null;
  }

  const Page = dynamicPageTemplates[template];

  return <Page {...(props as any)} />;
};
